import { createSelector } from '@reduxjs/toolkit';
import {
  selectProjectsDetails,
  selectOptionsPercentTotal,
  selectOptionsPlusTotal,
} from '../project/projectSelectros';

export const selectShopify = createSelector(
  selectProjectsDetails,
  projectsDetails => projectsDetails?.shopify || {}
);

export const selectShopifyCalculationParams = createSelector(
  selectShopify,
  projectOther => projectOther.calculationOptions || {}
);

export const selectShopifyPagesTotal = () => {
  return {
    discount: 0,
    totalPricePages: 0
  };
};

export const selectShopifyOptionsTotal = createSelector(
  selectShopifyPagesTotal,
  selectOptionsPlusTotal,
  selectOptionsPercentTotal,
  ({totalPricePages}, totalPricePlusOptions, totalPricePercentOptions) => {
    const  totalPriceOfPercent = Math.ceil((totalPricePercentOptions / 100) * totalPricePages);
    return totalPriceOfPercent + totalPricePlusOptions;
  }
);

export const selectShopifyTotal = createSelector(
  selectShopifyPagesTotal,
  selectShopifyOptionsTotal,
  ({totalPricePages}, totalPriceOptions) => totalPricePages + totalPriceOptions
);

export const selectShopifyTotalForAsap = createSelector(
    selectShopifyTotal,
    (totalPrice) => {
      return totalPrice / 2;
    }
);

export const selectShopifyEta = () => ({
  etaText: '',
  etaIsExists: false
});

export const selectShopifyDiscount = () => ({
  discountIsExists: false,
  discountText: '',
  discountPrice: 0,
});
